module.exports = __webpack_public_path__ + "static/media/Oct_2025_5.501b9a7c.webp";